<template>
  <main class="not-found-page">
    <section class="not-found-content iso-card">
      <div class="error-code">404</div>
      <p class="error-text">{{ $t('common.notFound') }}</p>
      <router-link to="/" class="iso-btn">{{ $t('common.backHome') }}</router-link>
    </section>
  </main>
</template>

<script setup lang="ts">
</script>

<style scoped>
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - var(--header-height));
  padding: 48px 24px;
}

.not-found-content {
  text-align: center;
  padding: 64px 48px;
  animation: iso-float 4s ease-in-out infinite;
}

.error-code {
  font-size: 96px;
  font-weight: 900;
  background: linear-gradient(135deg, var(--iso-cyan) 0%, #0066ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
  line-height: 1;
  margin-bottom: 16px;
  filter: drop-shadow(0 0 24px var(--iso-cyan-glow));
}

.error-text {
  font-size: 18px;
  color: var(--iso-text-dim);
  margin-bottom: 32px;
}
</style>
